import React from 'react';

/**
 * Stores the modal's close handler for any children that might need it.
 */
const ModalCloseContext = React.createContext<(e?: any) => void>(() => null);

export default ModalCloseContext;
